<template>
  <div class="family-balances">
    {{ $t('CP.wholeFamily') }}:
    <money-message
      :money-amount="balance | toTwoFixed"
      :type="getPayoutType"
      :currency="currency"
    />
  </div>
</template>

<script>
import MoneyMessage from '../MoneyMessagge/MoneyMessage';

export default {
  name: 'FamilyBalances',
  components: { MoneyMessage },
  props: {
    balance: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  computed: {
    getPayoutType() {
      const { balance } = this;
      if (balance > 0) {
        return 'accrual';
      }
      if (balance < 0) {
        return 'debit';
      }
      return 'neutral';
    },
  },
};
</script>

<style lang="scss" scoped>
  .family-balances {
    position: relative;
    padding-bottom: 10px;
    text-align: right;
    &::after {
      content: "";
      top: 0;
      right: 0;
      position: absolute;
      width: calc(100% + 15px);
      height: 102%;
      border-bottom: 2px solid var(--gray-lighten);
      border-left: 2px solid var(--gray-lighten);
    }
  }
</style>
